import React from 'react';
import Select from './common/Select';
import {languageOptions,validNumberRegex} from '../utils/constants';
import NumberInput from './common/NumberInput';
import PlainButton from './common/PlainButton';
import Mathjax from './common/Mathjax';
import Toggle from 'react-toggle'
import { DropdownIndicator } from '../utils/dropdown-override';
import ToolTip from './common/ToolTip';
import SetFontSizeComponent from './common/SetFontSizeComponent.jsx';
import SetCaseMenuSizeComponent from './common/SetCaseMenuSizeComponent.jsx';
import RangeFilterComponent from './attribute/range/RangeFilterComponent';
import AxisMajorMinorStepComponent from './attribute/range/AxisMajorMinorStepComponent';

class PlotSettingComponent extends React.Component {
    constructor(props) {
        super(props);

        let Dyn = this.props.Dyn,
            attributeOptions = [],
            orderByAttribute = Dyn.dataSet.getOrderByAttribute(),
            selectedByAttribute = Dyn.dataSet.getSelectedAttribute();

        this.updateXYAxisDelay = '';

        if (orderByAttribute)
            orderByAttribute = orderByAttribute.id;
        if (selectedByAttribute)
            selectedByAttribute = selectedByAttribute.id;

        //loop thru the attributes, to get value, lable pair dict
        Dyn.dataSet.attribs.map(function(item, i) {
            attributeOptions.push({ value: item.id, label: item.name, object:"PlotSettingsCard" });
        }.bind(this));

        this.state = {
            attributeOptions: attributeOptions,
            orderByAttribute: orderByAttribute,
            selectedByAttribute: selectedByAttribute,
            gridLines : Dyn.preferences.isGridLinesOn(),
            wantY2Axis : Dyn.preferences.wantY2Axis(),
            language : this.props.language,
            labels: Dyn.preferences.isStatsLabelOn(),
            isCustomIconOn: Dyn.plotView.plotShaper.iconStyler.isCustomCaseIconEnabled(),
            axisData : {
                rangeX : this.getAxisData( Dyn.plotView.xAxis ),
                rangeY : this.getAxisData( Dyn.plotView.yAxis ),
                rangeY2 : this.getAxisData( Dyn.plotView.y2Axis ),
            },
            hasBubbles: Dyn.plotView?.plotShaper.hasElement(Dyn.EPlotControl.kControlsBubbles)
        }
    }

    getAxisData = (axisView) => {
        // get axis range and steps numeric values; caller must format strings for input boxes, e.g. 0.5 => 1/2 fraction
        let r = axisView?.getNumericAxisRange(),
            s = axisView?.getNumericAxisSteps();
        return {
            min: r?.min,
            max : r?.max,
            minorStep: s?.minorStep,
            majorStep: s?.majorStep
        };
    }

    onKeyPressed = (e) => {
        if(e.keyCode === 27) {
            // Focus close button on esc
            this.refs.closeButton.focus();
        }
    }
    handleClose = (event) => {
        // To close the current view
        this.props.onClose();
    }
    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        return Dyn.loc( str );
    }
    changeHandler = (obj) => {
       this.setState({
            language : obj.value
        });
        this.props.switchLanguage( obj.value );
    }

    changeSelectedByAttribute = (obj) => {
        var attrObj = this.props.Dyn.dataSet.getAttributeByID(obj.value);
        if(this.props.onAttributeNameSelected) {
            this.props.onAttributeNameSelected(attrObj);
        }
        this.setState({
            selectedByAttribute : obj.value
        });
    }

    changeOrderByAttribute = (obj) => {
        var attrObj = this.props.Dyn.dataSet.getAttributeByID(obj.value);
        if(this.props.onOrderByAttributeSelected) {
            this.props.onOrderByAttributeSelected(attrObj);
        }
        this.setState({
            orderByAttribute : obj.value
        });
    }


    handleClickGridLines= ( value ) => {
        if (value !== this.state.gridLines) {
            this.setState({
                gridLines : value
            }, () => this.props.Dyn.preferences.setGridLinesOn(value));
        }
    }

    handleClickLabels = ( value ) => {
        if (value !== this.state.labels) {
            this.setState({
                labels: value
            }, () => this.props.Dyn.preferences.setStatsLabelOn(value) );
        }
    }

    handleClickDualAxis = ( value ) => {
        if (value !== this.state.wantY2Axis) {
            this.setState({
                wantY2Axis: value
            }, () => this.props.Dyn.preferences.setWantY2Axis(value) );
        }
    }

    handleClickCustomIcon = ( value ) => {
        if (value !== this.state.isCustomIconOn) {
            this.setState({
                isCustomIconOn: value
            }, () => this.props.Dyn.preferences.setCustomIconOn(value) );
        }
    }

    axisStepFormatted( numericValue, axis ) {
        // convert numeric value/undefined to formatted string for major/minor step input box
        // NOTE: uses relative units, e.g. "2 months" if the attribute on the axis is type numerical:date
        const Dyn = this.props.Dyn,
            axisView = (axis.startsWith('X')) ? Dyn.plotView.xAxis :
                         (axis.startsWith('Y2')) ? Dyn.plotView.y2Axis : Dyn.plotView.yAxis,
            attribute = axisView.getFormattingAttribute();
        let result = '';
        if( attribute && Number.isFinite( numericValue ) ) {
            result = attribute.axisValueToStringRelativeUnits( numericValue, Dyn.mathUtil.decimalPlaces( numericValue ) );
        }
        return result; // formatted string or empty string
    }

    axisStepStringToNumber( string, axis ) {
        // convert formatted string from major/minor step input box to numeric value
        // NOTE: uses relative units, e.g. "2 months" if the attribute on the axis is type numerical:date
        let Dyn = this.props.Dyn,
            isMajor = axis.endsWith('majorstep'),
            axisView = (axis.startsWith('X')) ? Dyn.plotView.xAxis :
                         (axis.startsWith('Y2')) ? Dyn.plotView.y2Axis : Dyn.plotView.yAxis,
            attribute = axisView.getFormattingAttribute();
        let dataFormat = {},
            numericValue = attribute?.axisInputToAxisValue( string, dataFormat, true /* isRelativeUnits */ );
        if( ((string.length === 0) || // empty input is allowed (to reset value to the default)
            ((string.substring(string.length-1) != ".") && (numericValue !== null))) && // not bad input like "1." or "1/"
            (isMajor ? Dyn.MajorMinorWidth.isValidMajorWidth( numericValue, axisView.coordMap, true) :
                      Dyn.MajorMinorWidth.isValidMinorWidth( numericValue, axisView.coordMap, true))) {
            return numericValue; // valid numeric value (non-negative) or null (Dyn.dataUtil.kMissingValue) if input is empty
        } else {
            return -1; // -1 means invalid input, wait for user to correct
        }
    }

    updateAxisValue = (value, axis) => {
        let Dyn = this.props.Dyn,
            validValue = false,
            numericValue;
        if(axis.endsWith('step')) {
            // For major step and minor step, convert string to numeric value
            numericValue = this.axisStepStringToNumber( value, axis );
            validValue = numericValue !== -1; // -1 means invalid input (non-negative number or null is valid)
            Dyn.debugging && console.log("updateAxisValue validValue=", validValue, value, "->", numericValue, axis );
        } else {
            // for min and max range values, value already converted to array of two numbers by subcomponent
            validValue = validNumberRegex.test(value[0]) && validNumberRegex.test(value[1]);
        }

        // NOTE: we do not warn the user of invalid input; consider highlighting the input box in red instead
        validValue && this.setState({
            axisData : {
                rangeX : {
                    min: axis == 'x'? value[0] : this.state.axisData.rangeX.min,
                    max: axis == 'x'? value[1] : this.state.axisData.rangeX.max,
                    minorStep: axis == 'Xminorstep'? numericValue : this.state.axisData.rangeX.minorStep,
                    majorStep: axis == 'Xmajorstep'? numericValue : this.state.axisData.rangeX.majorStep
                },
                rangeY : {
                    min: axis == 'y'? value[0] : this.state.axisData.rangeY.min,
                    max: axis == 'y'? value[1] : this.state.axisData.rangeY.max,
                    minorStep: axis == 'Yminorstep'? numericValue : this.state.axisData.rangeY.minorStep,
                    majorStep: axis == 'Ymajorstep'? numericValue : this.state.axisData.rangeY.majorStep
                },
                rangeY2 : this.state.wantY2Axis ? {
                    min: axis == 'y2'? value[0] : this.state.axisData.rangeY2.min,
                    max: axis == 'y2'? value[1] : this.state.axisData.rangeY2.max,
                    minorStep: axis == 'Y2minorstep'? numericValue : this.state.axisData.rangeY2.minorStep,
                    majorStep: axis == 'Y2majorstep'? numericValue : this.state.axisData.rangeY2.majorStep
                } : {}
            }
        }, this.updateXYAxis);
    }

    updateXYAxis = () => {
        clearTimeout(this.updateXYAxisDelay);
        this.updateXYAxisDelay = setTimeout(() => {
            this.props.Dyn.mediator.publish("axis:setMinMaxSteps", this.state.axisData)
        }, 1000);
    }

    componentDidMount = () => {
        let Dyn = this.props.Dyn;
        this.subscriptions = [];

        Dyn.mediatorLocalSubscribe( this.subscriptions, "plot:modelUpdated", ( data ) => {
            let axisData = {
                rangeX : this.getAxisData( Dyn.plotView.xAxis ),
                rangeY : this.getAxisData( Dyn.plotView.yAxis ),
                rangeY2 : this.getAxisData( Dyn.plotView.y2Axis ),
            };

            this.setState({
                axisData,
                labels : Dyn.preferences.isStatsLabelOn(),
                gridLines : this.props.Dyn.preferences.isGridLinesOn(),
                wantY2Axis : this.props.Dyn.preferences.wantY2Axis(),
                hasBubbles: Dyn.plotView?.plotShaper.hasElement(Dyn.EPlotControl.kControlsBubbles)
            });
        });
        // Focus the panel
        this.refs.plotSettingPanel.focus();
    }

    componentWillUnmount() {
       this.props.Dyn.mediatorLocalRemoveAll( this.subscriptions );
    }


    render = () => {
        // TODO: This check can be ignored when the plotview including casecard and table views are destroyed when switching to play view
        let plotView = this.props.Dyn.plotView;
        if(!plotView || !plotView.plotShaper) {
            return <></>;
        }
        function isAxisNumerical( axisView ) {
            return Boolean(
                axisView // axis view must exist
                && axisView.isNumericalScaleAxis() // must have a visible scale
                && (typeof axisView.getNumericAxisRange().min !== "undefined")); // and a numeric min value
        }
        let isXNumerical = isAxisNumerical( plotView.xAxis );
        let isYNumerical = isAxisNumerical( plotView.yAxis );
        let isY2Numerical = isAxisNumerical( plotView.y2Axis );
        let xAxisFirstAttribute = isXNumerical? plotView.xAxis.getFormattingAttribute() : null;
        let yAxisFirstAttribute = isYNumerical? plotView.yAxis.getFormattingAttribute() : null;
        let y2AxisFirstAttribute = isY2Numerical? plotView.y2Axis.getFormattingAttribute(): null;
        let isCustomOrderByAllowed = plotView.plotShaper.allowCustomOrderBy();
        let orderByTitle = plotView.plotShaper.isCustomOrderForLines() ? 'Order Lines By' : 'Order Cases By';
        let hasCustomIcon = plotView.plotShaper.iconStyler.hasCustomCaseIcon();
        let mode = this.props.mode || 'default';

        return (
        <div className="tde-fill" ref="plotSettingPanel" onKeyDown={this.onKeyPressed} tabIndex="0" style={this.props.style}>
            <div className="tde-sliding-panel-header tde-divider-bottom">
                <div>
                    <span
                        className="tde-ml-2 tde-h6 tde-font-weight-bold"
                        role="heading"
                        aria-level="1">{ this.getLoc('PLOT SETTINGS CARD') }</span>
                </div>
                <PlainButton title="Close" ref="closeButton" aria-label={this.getLoc('Close Plot Settings Card')} onClick={this.handleClose} className="tde-mx-2 tde-close-attr-settings"><i className="tde-i tde-i-remove"></i></PlainButton>
            </div>
            <div className="tde-sliding-panel-body tde-plot-settings-body tde-card-content-bg-color tde-pt-2">
                <div className={this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3'}>
                    <div className="tde-my-2 tde-s1-size tde-align-center tde-d-flex">
                        <p className="tde-label tde-flex-1 tde-font-weight-bold">{ this.getLoc('Color Cases By') }<ToolTip tip={this.getLoc('Color cases by selected attribute')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1" aria-label={this.getLoc('Color cases by selected attribute')}><span className="tde-sr-only">{this.getLoc('Color cases by selected attribute')}</span></i></ToolTip></p></div>
                    <div className="tde-s1-size tde-align-center tde-d-flex">
                        <Select
                            id="tde-case-color-select"
                            Dyn={this.props.Dyn}
                            aria-label={this.getLoc('Color cases by selected attribute')}
                            className="tde-input tde-flex-1 tde-select-input tde-input-select tde-color-case"
                            isClearable={false}
                            value={this.state.attributeOptions.find(obj => obj.value === this.state.selectedByAttribute) }
                            options={this.state.attributeOptions}
                            // openMenuOnFocus
                            isSearchable={false}
                            tabSelectsValue={false}
                            placeholder={<div className='tde-select-placeholder'>{this.getLoc('Select')+'...'}</div>}
                            onChange={this.changeSelectedByAttribute}
                            components={{
                                Option: ({ data, innerProps, children, innerRef, isSelected, isFocused }) => (
                                    <div
                                        className={'tde-select-option' + (isSelected ? ' tde-selected' :"") + (isFocused ? ' tde-focused' : '')}
                                        role="option"
                                        aria-selected={isSelected ? "true" : "false"}
                                        title={data.title}
                                        {...innerProps}
                                        ref={innerRef}
                                    >
                                        <div className="tde-s1"><Mathjax value={children} /></div>
                                    </div>
                                ),
                                DropdownIndicator
                            }}
                        />
                    </div>

                {isCustomOrderByAllowed && <div>
                    <div className="tde-align-center tde-s1-size tde-d-flex tde-mt-3 tde-mb-2">
                    <p className="tde-label tde-fill tde-font-weight-bold">{ this.getLoc(orderByTitle) }<ToolTip tip={this.getLoc('Order cases by selected attribute')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1" aria-label={this.getLoc('Order cases by selected attribute')}><span className="tde-sr-only">{this.getLoc('Order cases by selected attribute')}</span></i></ToolTip></p></div>
                    <div className="tde-s1-size tde-align-center tde-d-flex">
                    <Select
                        id="tde-case-order-select"
                        Dyn={this.props.Dyn}
                        aria-label={this.getLoc('Order Cases By')}
                        className="tde-input tde-flex-1 tde-select-input tde-input-select tde-order-case"
                        isClearable={false}
                        value={this.state.attributeOptions.find(obj => obj.value === this.state.orderByAttribute) }
                        options={this.state.attributeOptions}
                        // openMenuOnFocus
                        isSearchable={false}
                        tabSelectsValue={false}
                        onChange={this.changeOrderByAttribute}
                        placeholder={<div className='tde-select-placeholder'>{this.getLoc('Select')+'...'}</div>}
                        components={{
                            MenuList: ({ children, ...props }) => (
                                <div role="listbox" {...props}>
                                    {children}
                                </div>
                            ),
                            Option: ({ data, innerProps, children, innerRef, isSelected, isFocused }) => (
                                <div
                                    className={'tde-select-option' + (isSelected ? ' tde-selected' :"") + (isFocused ? ' tde-focused' : '')}
                                    role="option"
                                    aria-selected={isSelected ? "true" : "false"}
                                    title={data.title}
                                    {...innerProps}
                                    ref={innerRef}
                                >
                                    <div className="tde-s1"><Mathjax value={children} /></div>
                                </div>
                            ),
                            DropdownIndicator
                        }}
                    />
                </div>
            </div>}

                {isXNumerical && xAxisFirstAttribute && <div className="tde-mt-3 tde-s1-size tde-minmax-input">
                    <p className="tde-font-weight-bold tde-label tde-fill">{ this.getLoc('X-Axis Range') }</p>
                    <RangeFilterComponent
                        min={this.state.axisData.rangeX.min}
                        max={this.state.axisData.rangeX.max}
                        Dyn={this.props.Dyn}
                        type={xAxisFirstAttribute.getDataType(true)}
                        attributeObj={xAxisFirstAttribute}
                        label={this.getLoc('X-Axis Range')}
                        onChange={value => this.updateAxisValue(value,'x')}
                    />
                    <AxisMajorMinorStepComponent
                        major={this.axisStepFormatted(this.state.axisData.rangeX.majorStep, 'Xmajorstep')}
                        minor={this.axisStepFormatted(this.state.axisData.rangeX.minorStep, 'Xminorstep')}
                        onChange={this.updateAxisValue}
                        Dyn={this.props.Dyn}
                        axis="X"
                        />
                </div>}

                {isYNumerical && yAxisFirstAttribute && <div className="tde-mt-3 tde-s1-size tde-minmax-input">
                    <p className="tde-font-weight-bold tde-label tde-fill">{ isY2Numerical ? this.getLoc('Y1-Axis Range') : this.getLoc('Y-Axis Range')}</p>
                    <RangeFilterComponent
                        min={this.state.axisData.rangeY.min}
                        max={this.state.axisData.rangeY.max}
                        Dyn={this.props.Dyn}
                        type={yAxisFirstAttribute.getDataType(true)}
                        attributeObj={yAxisFirstAttribute}
                        label={isY2Numerical ? this.getLoc('Y1-Axis Range') : this.getLoc('Y-Axis Range')}
                        onChange={value => this.updateAxisValue(value,'y')}
                    />
                    <AxisMajorMinorStepComponent
                        major={this.axisStepFormatted(this.state.axisData.rangeY.majorStep, 'Ymajorstep')}
                        minor={this.axisStepFormatted(this.state.axisData.rangeY.minorStep, 'Yminorstep')}
                        onChange={this.updateAxisValue}
                        Dyn={this.props.Dyn}
                        axis="Y"
                        />
                </div>}

                {isY2Numerical && y2AxisFirstAttribute && <div className="tde-mt-3 tde-s1-size tde-minmax-input">
                    <p className="tde-font-weight-bold tde-label tde-fill">{ this.getLoc('Y2-Axis Range') }</p>
                    <RangeFilterComponent
                        min={this.state.axisData.rangeY2.min}
                        max={this.state.axisData.rangeY2.max}
                        Dyn={this.props.Dyn}
                        type={y2AxisFirstAttribute.getDataType(true)}
                        attributeObj={y2AxisFirstAttribute}
                        label={this.getLoc('Y2-Axis Range')}
                        onChange={value => this.updateAxisValue(value,'y2')}
                    />
                    <AxisMajorMinorStepComponent
                        major={this.axisStepFormatted(this.state.axisData.rangeY2.majorStep, 'Y2majorstep')}
                        minor={this.axisStepFormatted(this.state.axisData.rangeY2.minorStep, 'Y2minorstep')}
                        onChange={this.updateAxisValue}
                        Dyn={this.props.Dyn}
                        axis="Y2"
                        />
                </div>}
            </div>

                {/* For Dual Axis */}
                <div className='tde-divider-top tde-mt-4'>
                    <div className={(this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3') + ' tde-py-4'}>
                    {!['elem', 'jr'].includes(mode) && plotView.isDualAxisAllowed() && <div className="tde-s1-size tde-d-flex tde-align-center tde-mb-3">
                            <p className="tde-label tde-flex-1 tde-font-weight-bold">{ this.getLoc('Dual Axis') }<ToolTip tip={this.getLoc('Add second y-axis to scatter plot or line plot')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1" aria-label={this.getLoc('Add second y-axis to scatter plot or line plot')}><span className="tde-sr-only">{this.getLoc('Add second y-axis to scatter plot or line plot')}</span></i></ToolTip></p>
                                <Toggle
                                    checked={this.state.wantY2Axis}
                                    className='black-toggle'
                                    icons={false}
                                    aria-label={`${this.getLoc('Dual Axis')}, ${this.state.wantY2Axis ? 'checked' : 'unchecked'}, checkbox`}
                                    onChange={e => {
                                        this.handleClickDualAxis(e.target.checked)
                                    }} />

                        </div>}
                        <div className="tde-s1-size tde-d-flex tde-align-center">
                            <p className="tde-label tde-flex-1 tde-font-weight-bold">{ this.getLoc('Grid Lines') }<ToolTip tip={this.getLoc('Add gridlines to the plotting area')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1" aria-label={this.getLoc('Add gridlines to the plotting area')}><span className="tde-sr-only">{this.getLoc('Add gridlines to the plotting area')}</span></i></ToolTip></p>
                                <Toggle
                                    checked={this.state.gridLines}
                                    className='black-toggle'
                                    icons={false}
                                    aria-label={`${this.getLoc('Grid Lines')}, ${this.state.gridLines ? 'checked' : 'unchecked'}, checkbox`}
                                    onChange={e => {
                                        this.handleClickGridLines(e.target.checked)
                                    }} />
                        </div>
                        <div className="tde-s1-size tde-d-flex tde-align-center tde-mt-3">
                            <p className="tde-label tde-flex-1 tde-font-weight-bold">{ this.getLoc('Labels') }<ToolTip tip={this.getLoc('Add labels in the plotting area')} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1" aria-label={this.getLoc('Add labels in the plotting area')}><span className="tde-sr-only">{this.getLoc('Add labels in the plotting area')}</span></i></ToolTip></p>
                                <Toggle
                                    checked={this.state.labels}
                                    className='black-toggle'
                                    icons={false}
                                    aria-label={`${this.getLoc('Labels')}, ${this.state.labels ? 'checked' : 'unchecked'}, checkbox`}
                                    onChange={e => {
                                        this.handleClickLabels(e.target.checked)
                                    }} />
                        </div>
                    </div>
                </div>
                <div className='tde-divider-top tde-mb-3'></div>
                <div className={this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3'}>
                    <div className="tde-align-center tde-s1-size tde-d-flex tde-mt-4">
                        <p className="tde-label tde-fill tde-font-weight-bold tde-pb-2">{ this.getLoc('Language') }<ToolTip tip={'Change Language for Tuva Tools Interface'} Dyn={this.props.Dyn} dir="r"><i className="tde-i tde-i-help tde-ml-1" aria-label={'Change Language for Tuva Tools Interface'}><span className="tde-sr-only">{'Change Language for Tuva Tools Interface'}</span></i></ToolTip></p></div>
                    <div className="tde-s1-size tde-align-center tde-d-flex">
                        <Select
                            id="tde-case-language-select"
                            Dyn={this.props.Dyn}
                            aria-label={'Change Language for Tuva Tools Interface'}
                            menuPlacement="top"
                            className="tde-input tde-flex-1 tde-select-input tde-input-select"
                            isClearable={false}
                            value={{
                                label : languageOptions.find(obj => obj.value === this.state.language).label,
                                value : this.state.language
                            }}
                            options={languageOptions}
                            // openMenuOnFocus
                            isSearchable={false}
                            tabSelectsValue={false}
                            onChange={this.changeHandler}
                            placeholder={<div className='tde-select-option'>{this.getLoc('Select')+'...'}</div>}
                            components={{
                                Option: ({ data, innerProps, children, innerRef, isSelected, isFocused }) => (
                                    <div
                                        className={'tde-select-option' + (isSelected ? ' tde-selected' :"") + (isFocused ? ' tde-focused' : '')}
                                        role="option"
                                        aria-selected={isSelected ? "true" : "false"}
                                        title={data.title}
                                        {...innerProps}
                                        ref={innerRef}
                                    >
                                        <div className="tde-s1">{children}</div>
                                    </div>
                                ),
                                DropdownIndicator
                            }}
                        />
                    </div>
                    <div className="tde-align-center tde-s1-size tde-d-flex tde-mt-4">
                    <p className="tde-label tde-fill tde-font-weight-bold tde-pb-2">{ this.getLoc('Font Size') }</p></div>
                    <SetFontSizeComponent reduceCaseCardWidth={this.props.reduceCaseCardWidth} getLoc={this.getLoc} Dyn={this.props.Dyn}/>
                    <div className="tde-align-center tde-s1-size tde-d-flex tde-mt-4">
                    <p className="tde-label tde-fill tde-font-weight-bold tde-pb-2">{
                        this.getLoc( this.state.hasBubbles ? "Bubble Size" : "Case Size" )
                    }</p></div>
                    <SetCaseMenuSizeComponent reduceCaseCardWidth={this.props.reduceCaseCardWidth} getLoc={this.getLoc} Dyn={this.props.Dyn}/>
                </div>

                {hasCustomIcon && <div className="tde-pb-4 tde-mt-4 tde-divider-bottom">
                    <div className={"tde-s1-size tde-d-flex tde-align-center" + (this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3')}>
                            <p className="tde-flex-1 tde-label tde-font-weight-bold">{ this.getLoc('Custom Case Icon') }</p>
                                <Toggle
                                    checked={this.state.isCustomIconOn}
                                    className='black-toggle'
                                    icons={false}
                                    aria-label={`${this.getLoc('Custom Case Icon')}, ${this.state.isCustomIconOn ? 'checked' : 'unchecked'}, checkbox`}
                                    onChange={e => {
                                        this.handleClickCustomIcon(e.target.checked)
                                    }} />
                        </div>
                </div>}

                <div className="tde-mb-6"></div>
                </div>
            </div>
        );
    }
}

export default PlotSettingComponent
